import Vue from 'vue'
/**
 * @author Suhipney R. <suhiipney@gmail.com>
 * Fetches all users included in a group
 * @return {Array} An Array with all groups
 */

export default () =>
  Vue.$http.get(`users/groups/`)
    .then(response => response.data)
